import request from "@/utils/request";
// 专题活动详情
export const  activityInfo =(query) =>{
    return request({
        url: "/authservice/eduActivity/activity/info",
        method:"get",
        params: query
    })
}

//提交报名资料
export const  signUpActivity =(data) =>{
    return request({
        url: "/authservice/eduActivity/activity/signUp",
        method:"post",
        data: data
    })
}

// 查询报名资料
export const  infoActivitySignUp =(query) =>{
    return request({
        url: "/authservice/eduActivity/activity/signInfo",
        method:"get",
        params: query
    })
}

//活动报名用户列表
export const  pageActivitySign =(data) =>{
    return request({
        url: "/authservice/eduActivity/activity/pageSign",
        method:"post",
        data: data
    })
}

//上传视频资料
export const  uploadVideo =(data) =>{
    return request({
        url: "/authservice/eduActivity/file/uploadVideo",
        method:"post",
        data: data
    })
}